module.exports = __webpack_public_path__ + "images/application/templates/layout-plain@2x-6148c91f.png";